// extracted by mini-css-extract-plugin
export var animationAbsolute = "_27-q";
export var animationRelative = "_27-p";
export var backdropBlur = "_27-0";
export var detailLabelCell = "_27-12";
export var detailTable = "_27-11";
export var detailValueCell = "_27-13";
export var docIconBox = "_27-1d";
export var docIconBoxMd = "_27-1f";
export var docIconBoxSm = "_27-1e";
export var docTypeRow = "_27-16";
export var docTypeRowInner = "_27-17";
export var dropdownMatchDatePicker = "_27-3";
export var evidenceCardContent = "_27-1c";
export var fileUploadSpin = "_27-j";
export var gorgiasOpenButton = "_27-15 _27-d";
export var gorgiasTicketCard = "_27-14";
export var heroModalFooterButton = "_27-18";
export var hiddenContainer = "_27-o";
export var iconPrimary = "_27-1g";
export var iconSecondary = "_27-1h";
export var iconTertiary = "_27-1i";
export var integrationCard = "_27-1";
export var integrationLogoBox = "_27-2";
export var mainColumnSticky = "_27-1b";
export var maxWidthContainer = "_27-19";
export var modalContentBody = "_27-a";
export var modalHeaderImage = "_27-5";
export var modalImageLabel = "_27-7";
export var modalImageOverlay = "_27-6";
export var modalImageSubtitle = "_27-9";
export var modalImageTitle = "_27-8";
export var modalImageWrapper = "_27-4";
export var modalStickyFooter = "_27-b";
export var removeButton = "_27-e";
export var sidebarColumn = "_27-1a";
export var spinner = "_27-i";
export var timelineLine = "_27-y";
export var timelineLineBlack = "_27-10 _27-y";
export var timelineLineGray = "_27-z _27-y";
export var timelineLineHeight = "_27-x";
export var tlDotActivate = "_27-u";
export var tlDotActivateAnim = "_27-t";
export var tlDotHide = "_27-s";
export var tlDotHideAnim = "_27-r";
export var tlLineActivate = "_27-w";
export var tlLineActivateAnim = "_27-v";
export var uploadHint = "_27-n";
export var uploadIconBox = "_27-k";
export var uploadLabel = "_27-m";
export var uploadText = "_27-l";
export var uploadZone = "_27-f";
export var uploadZoneCursorDefault = "_27-h";
export var uploadZoneCursorPointer = "_27-g";
export var uploadedFileRow = "_27-c";
export var viewButton = "_27-d";